<div class="details-dialog-container" *ngIf="isFormReady">
	<div class="form">
		<p-blockUI [target]="pnl" [blocked]="isSubmitting">
			<i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
		</p-blockUI>
		<p-card #pnl>
			<div class="row">
				<div class="col-md-12">
					<cv-form-field
						[options]="{
							path: 'reasonCode'
						}"
					></cv-form-field>
				</div>
				<div class="col-md-12">
					<cv-form-field
						[options]="{
							path: 'comment'
						}"
					></cv-form-field>
				</div>
			</div>
		</p-card>
	</div>

	<div class="row mt-4 justify-content-end">
		<div class="col-2">
			<button class="btn btn-sm" (click)="dialogRef.close()">Cancel</button>
		</div>
		<div class="col-2">
			<button class="btn btn-sm cv-btn-blue" [disabled]="form.invalid || isSubmitting" (click)="submit()">
				Override
			</button>
		</div>
	</div>
</div>
